// Copyright (c) 2020 Deere & Company

import './index.scss';

import AuthenticatedPage from '../../common/components/authenticated-page';
import PastDueShipments from './past-due-shipments';
import React from 'react';

function PastDueShipmentsPage () {

    return (
        <AuthenticatedPage className="atp-page atp-past-due-shipments-page">
            <PastDueShipments />
        </AuthenticatedPage>
    );

}
PastDueShipmentsPage.displayNAme = 'PastDueShipmentsPage';

export default PastDueShipmentsPage;
